// export const BASE_URL = "http://192.168.1.71:8080/api/v1/";
// export const BASE_URL = "http://192.168.1.72:8080/api/v1/";
export const BASE_URL = "https://portal.creatofox.com/api/v1/";
export const ACCEPT_HEADER = "application/x.expocrm.v1+json";

export const get_current_expo_url = BASE_URL + "get-current-expo"; //HomePage
export const get_edition_expo_url = BASE_URL + "get-edition-expo"; //EditionPage
export const get_edition_category_url = BASE_URL + "get-edition-category"; //Navbar

export const get_curtain_raiser_category_url =
  BASE_URL + "get-curtain-raiser-category"; //HomeVideo/CurtainRaiserVideoPage
export const get_curtain_raiser_url = BASE_URL + "get-curtain-raiser"; //HomeVdideo/CurtainRaiserVideoPage
export const get_voice_category_url = BASE_URL + "get-voice-category"; //HomeVideo/VoiceOfBBVideoPage
export const get_voice_url = BASE_URL + "get-voice"; //HomeVideo/VoiceOfBBVideoPage
export const get_sponser_category_url = BASE_URL + "get-sponser-category"; //HomeOurPartner
export const get_current_contact_url = BASE_URL + "get-current-contact"; //Footer

export const get_aboutus_url = BASE_URL + "get-aboutus"; //AboutUsPage
export const get_director_url = BASE_URL + "get-director"; //DirectorsPage
export const get_exhibition_url = BASE_URL + "get-exhibition"; //ExhibitionPage
export const get_conference_url = BASE_URL + "get-conference"; //ConferencePage
export const get_whyvisit_url = BASE_URL + "get-whyvisit"; //WhyVisitPage
export const get_contact_us_url = BASE_URL + "get-contact-us"; //ContactUsPage
export const expo_contact_us_url = BASE_URL + "expo-contact-us"; //ContactUsPage
export const get_register_form_url = BASE_URL + "get-register-form"; //RegistrationPage
export const get_register_detail_expo_url =
  BASE_URL + "get-register-detail-expo"; //DomasticPage/InternationalPage/ExhibitorPage
export const visitor_format_url = BASE_URL + "visitor-format"; //DomasticPage/InternationalPage/ExhibitorPage
export const submit_domestic_visitor_url = BASE_URL + "submit-domestic-visitor"; //DomasticPage
export const submit_international_visitor_url =
  BASE_URL + "submit-international-visitor"; //InternationalPage
export const submit_exhibitor_visitor_url =
  BASE_URL + "submit-exhibitor-visitor"; //ExhibitorPage
export const submit_manufacturer_exhibitor_url =
  BASE_URL + "submit-manufacturer-exhibitor";

export const get_country_url = BASE_URL + "get-country";
export const get_state_url = BASE_URL + "get-state";
export const get_city_url = BASE_URL + "get-city";
